module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/users/user-single/user-single.component.css
// module id = ./src/app/users/user-single/user-single.component.css
// module chunks = main